/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {FlagConfigurationModel} from './flag-configuration.model';

@Component({
    selector: 'app-flag',
    templateUrl: './flag.component.html',
    styleUrls: ['./flag.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FlagComponent {
    @Input() configuration: FlagConfigurationModel;

    get flagClass(): string {
        let flagWrapper = 'flag-wrapper';
        if (this.configuration.backgroundClass != null) {
            flagWrapper += ` ${this.configuration.backgroundClass}`;
        }
        return flagWrapper;
    }

    get flagLabelStyle(): { [key: string]: any } {
        let style = {'color': '#000000'};
        if (this.configuration.textColor != null) {
            style = {'color': this.configuration.textColor};
        }
        return style;
    }
}
